import React from 'react';
import FormField from 'mrf/view/FormField';
import { useTranslation } from 'react-i18next';
import Input from './Input';
import { StyledSelect } from 'styles/components/Select.styles';

const SelectComponent = p => <Input component={StyledSelect} {...p} />;

const valueMapper = e => e.target.value;

export default function Select({ noneText, children, ...props }) {
    const { t } = useTranslation();

    return (
        <FormField
            component={SelectComponent}
            eventMapper={valueMapper}
            as='select'
            {...props}
        >
            {noneText && <option value='' className='italic'>{t(noneText)}</option>}
            {children}
        </FormField>
    );
}
